
import {useStore} from './useStore';

export const useLinkProductsFilterCount = () : number => {
    const filters = useStore( store => store.ui.linkProducts);

    let activeFilterCount = 0;
    if (filters.searchFilter) {
        activeFilterCount++;
    }

    return activeFilterCount;
}